export interface RecordChainEntry {
	rid: string;
	segment: string | null;
	tab: number | null;
}

export type RecordChain = readonly RecordChainEntry[];

export const EMPTY_CHAIN: RecordChain = [];

export function chainRid(chain: RecordChain, depth = 0): string | null {
	return chain[depth]?.rid ?? null;
}

export function chainTab(chain: RecordChain, depth = 0): number | null {
	return chain[depth]?.tab ?? null;
}

export function encodeChainTabs(chain: RecordChain): string | null {
	const parts = chain.map((entry) => (entry.tab === null ? '' : String(entry.tab)));
	while (parts.length > 0 && parts[parts.length - 1] === '') parts.pop();
	return parts.length === 0 ? null : parts.join('.');
}

export function decodeChainTabs(value: string | null): (number | null)[] {
	if (value === null || value === '') return [];
	return value.split('.').map((part) => (/^\d+$/.test(part) ? Number(part) : null));
}

export function withChainTabs(
	rids: readonly { rid: string; segment: string | null }[],
	tabs: readonly (number | null)[],
): RecordChain {
	return rids.map((entry, depth) => ({ ...entry, tab: tabs[depth] ?? null }));
}

export function chainsEqual(a: RecordChain, b: RecordChain): boolean {
	if (a.length !== b.length) return false;
	return a.every((entry, i) => entry.rid === b[i].rid && entry.tab === b[i].tab);
}

export function rootRecordChanged(a: RecordChain, b: RecordChain): boolean {
	return chainRid(a) !== chainRid(b);
}
